import { ApiConfig } from '@configs';

export interface FetchHelperPromiseReject {
	metadata?: {
		error?: {
			code?: number;
			message?: string;
		};
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	data?: any;
}

export class FetchHelper {
	static get = async <B = object, T = object>(url: string, body: B | undefined = undefined): Promise<T> => {
		return FetchHelper.fetch(url, 'GET', body, ApiConfig.headers);
	};

	static post = async <B = object, T = object>(url: string, body: B | undefined = undefined): Promise<T> => {
		return FetchHelper.fetch(url, 'POST', body, ApiConfig.headers);
	};

	static fetch = async <B = object, T = object>(
		url: string,
		method: 'GET' | 'POST' = 'POST',
		body?: B,
		headers = {}
	): Promise<T> => {
		const controller = new AbortController();

		try {
			const res = await fetch(url, {
				method: method,
				signal: controller.signal,
				body: typeof body === 'object' ? JSON.stringify(body) : undefined,
				headers: {
					'Content-Type': 'application/json',
					accept: 'application/json',
					...headers,
				},
			});

			const result: T = await res.json();

			if (!res.ok) {
				return Promise.reject({
					metadata: {
						error: {
							code: res.status,
							message: res.statusText,
						},
					},
					data: result,
				} as FetchHelperPromiseReject);
			}

			return result;
		} catch (err) {
			return Promise.reject({
				metadata: {
					error: {
						message: err,
					},
				},
			} as FetchHelperPromiseReject);
		} finally {
			controller.abort();
		}
	};
}
